import VaspTableFilter from './VaspTableFilter'

export default VaspTableFilter
